import { GradFlow } from 'gradflow';

// Pink-branded animated gradient background
// Colors: Hot Pink (#ff0090), Pink (#ff69b4), Dark Purple accent
export default function GradientBackground() {
  return (
    <div className="fixed inset-0 -z-10 bg-[#0a0a0f]">
      <GradFlow
        className="absolute inset-0 opacity-80"
        config={{
          color1: { r: 255, g: 0, b: 144 },    // #ff0090 - Knalliges Pink
          color2: { r: 255, g: 105, b: 180 },  // #ff69b4 - Hot Pink
          color3: { r: 20, g: 0, b: 30 },      // Near-black purple
          speed: 0.4,
          scale: 1,
          type: 'smoke',
          noise: 0.1
        }}
      />
    </div>
  );
}
